import styled from 'styled-components';
import {commonStyleMixin} from "./common";
import InputErrorWrapper from "./InputErrorWrapper";
import LabelWrapper from './LabelWrapper';
import {forwardRef} from 'react';

const TextInputStyled = styled.input`
  ${commonStyleMixin}
`;

const TextInput = forwardRef(({hasError, errorMessage, ErrorComponent, label, name, style, ...rest}, ref) => (
  <LabelWrapper
    name={name}
    label={label}
    style={style}
  >
    <InputErrorWrapper
      errorMessage={errorMessage}
      ErrorComponent={ErrorComponent}
      hasError={hasError}
    >
      <TextInputStyled
        ref={ref}
        hasError={hasError}
        name={name}
        id={name}
        { ...rest }
      />
    </InputErrorWrapper>
  </LabelWrapper>
));

export default TextInput;